import { CheckSVGIcon } from "assets";
import * as React from "react";
import { Modal } from "react-bootstrap";
import styles from "./toast.module.css";

interface ToastProps {
  heading: string;
  text: string;
  closeModal: () => void;
  show: boolean;
  type: boolean;
}

const Toast: React.FC<ToastProps> = ({
  heading,
  text,
  closeModal,
  show,
  type,
}) => {
  return (
    <>
      <Modal
        dialogClassName={styles.dialog}
        contentClassName={
          type ? styles["content-green"] : styles["content-red"]
        }
        show={show}
        onHide={closeModal}
      >
        <Modal.Body className={styles.body}>
          {type ? (
            <CheckSVGIcon className={styles["v-toast-img"]} title="check" />
          ) : (
            <div className={styles["v-toast-red-icon"]}>&times;</div>
          )}
          <div>
            <h6 className={styles["v-toast-ttl"]}>{heading}</h6>
            <p className={styles["v-toast-txt"]}>{text}</p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Toast;
